module.exports = __webpack_public_path__ + "static/media/forside.055d09b1.jpg";